export default __webpack_public_path__ + "locales/sq-AL/FillPDFDialog.json?hash=87ef827f0ae8d6f0957d5ed5c87067f4";